import React from "react";
import type { Store } from "../../types/store";
import { Edit } from "lucide-react";

interface Props {
  store: Store;
  selected: boolean;
  onSelect: (id: string, checked: boolean) => void;
  onEdit: (store: Store) => void;
}

const StoreCard: React.FC<Props> = ({ store, selected, onSelect, onEdit }) => {
  return (
    <div className="relative bg-white rounded-2xl border p-4 shadow-sm flex flex-col h-full">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-3">
          <input
            type="checkbox"
            checked={selected}
            onChange={(e) => onSelect(store.id, e.target.checked)}
            className="mt-1"
            aria-label={`Select ${store.name}`}
          />
          <div className="text-left">
            <h3 className="text-lg font-semibold">{store.name}</h3>
            <p className="text-xs text-gray-500">{store.location}</p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <button
            title="Edit store"
            onClick={() => onEdit(store)}
            className="p-2 rounded-md hover:bg-gray-100"
            aria-label={`Edit ${store.name}`}
          >
            <Edit />
          </button>
        </div>
      </div>

      <div className="mt-4 flex-1 flex flex-col justify-between">
        <div className="text-left">
          <p className="text-sm text-gray-600">Manager{(store.managers?.length !== undefined && store.managers?.length> 1) && 's'}</p>
          <p className="flex gap-2">
            {store.managers?.length
              ? store.managers.map((manager, index) => (
                  <span key={manager.id || index} className="text-xs bg-gray-100 px-2 py-1 rounded-full">
                    {manager.name ?? "Unassigned"}
                  </span>
                ))
              : "Unassigned"}
          </p>
          <div className="mt-3 text-primary grid grid-cols-2 gap-3">
            <div className="text-sm">
              <p className="text-xs">Employees</p>
              <p className="font-semibold">{store.employeeCount ?? 0}</p>
            </div>
            <div className="text-sm">
              <p className="text-xs">Sales</p>
              <p className="font-semibold">{store.salesCount ?? 0}</p>
            </div>
          </div>
        </div>

        <div className="mt-4 flex items-center justify-between text-xs text-gray-400">
          <span>Created: {store.createdAt?.slice(0, 10)}</span>
          <span>Updated: {store.updatedAt?.slice(0, 10)}</span>
        </div>
      </div>
    </div>
  );
};

export default StoreCard;
